// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-header[data-v-e1ed4bcc] {\n  position: -webkit-sticky;\n  position: sticky;\n  z-index: 200;\n  margin: -20px -20px 0;\n  padding: 20px;\n  background-color: #F5F5F5;\n}\n.page-header[data-v-e1ed4bcc] .page-title {\n  display: inline-block;\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  border-left: solid 1rem var(--primary-color);\n  padding-left: 1rem;\n  font-weight: bold;\n  font-size: x-large;\n  padding-top: 0.4rem;\n}", ""]);
// Exports
module.exports = exports;
